import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Inject, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "../../../services/dialog.service";
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "rf-privado-error",
  templateUrl: "./rf-privado-error.component.html",
  styleUrls: ["./rf-privado-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class RfPrivadoErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ngOnInit(): void {}

  ColumnsPrivateFixedIncome: string[] = [
    "settlementTypeId",
    "operationTypeId",
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioCetipAccount",
    "amount",
    "unitPrice",
    "IsSecondaryMarket",
    "operationValue",
    "assetType",
    "assetCode",
    "expirationDate",
    "issueFee",
    "issueDate",
    "issuer",
    "index",
    "indexPercent",
    "indexBase",
    "interestType",
    "settlementDate",
    "acquisitionDate",
    "subscriptionDate",
    "operationCode",
    "isCetipVoice",
    "voiceNumber",
    "propositionNumber",
    "isNewCounterpart",
    "counterpartName",
    "counterpartType",
    "counterpartDocument",
    "counterpartBank",
    "counterpartBranch",
    "counterpartAccount",
    "annotations",
  ];
}
